import React from "react";
import { useSwitchStyles } from "./switch.styles";

export interface SwitchProps {
  id: string;
  disabled?: boolean;
  label?: string;
  name: string;
  checked?: boolean;
  onChange: (e: any) => void;
}

export const Switch = ({
  id,
  disabled,
  label,
  name,
  onChange,
  checked,
  ...props
}: SwitchProps) => {
  const classes = useSwitchStyles({ disabled });

  return (
    <div>
      <div className={classes.CheckBoxWrapper}>
        <input
          name={name}
          className={classes.CheckBox}
          onChange={onChange}
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          {...props}
        />
        <label className={classes.CheckBoxLabel} htmlFor={id} />
        <span className={classes.ContentWrapper}>{label}</span>
      </div>
    </div>
  );
};
